export function getToken() {
  try {
    return (
      localStorage.getItem("token") ||
      sessionStorage.getItem("token") ||
      null
    );
  } catch (e) {
    console.error("Token okunamadı:", e);
    return null;
  }
}